export const SEnergyColumns = [{
    title: 'SN',
    dataIndex: "SerialNumber",
    width: 160,
    fixed: 'left',
}, {
    title: 'CreateTime',
    dataIndex: 'CreateTime',
    width: 160,
    fixed: 'left',
}, {
    title: 'Inverter Model Name',
    dataIndex: 'ModelName',
    width: 160,
}, {
    title: 'Display Format',
    dataIndex: 'DisplayFormat',
    width: 200,
}, {
    title: 'DSP1 Version',
    dataIndex: 'DSP1Version',
    width: 160,
}, {
    title: 'DSP2 Version',
    dataIndex: 'DSP2Version',
    width: 160,
}, {
    title: 'DSP3 Version',
    dataIndex: 'DSP3Version',
    width: 160,
}, {
    title: 'CSB Version',
    dataIndex: 'CSBVersion',
    width: 160,
}, {
    title: 'Mode',
    dataIndex: 'Mode',
    width: 160,
}, {
    title: 'EMS Status',
    dataIndex: 'EMSStatus',
    width: 160,
}, {
    title: 'Temp(°C)',
    dataIndex: 'Temp',
    width: 160,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fff) v = v - 0x10000;
        return v; 
    },
    transform: {
        signed: 0x7ffff,
    }
}, {
    title: 'Total Run Time(min)',
    dataIndex: 'HTotal',
    width: 160,
}, {
    title: 'Self-Consumption Per Day(%)',
    dataIndex: 'SelfConsumptionDay',
    width: 200,
}, {
    title: 'Self-Sufficiency Per Day(%)',
    dataIndex: 'SelfSufficiencyDay',
    width: 200,
}, {
    title: 'Self-Consumption Per Month(%)',
    dataIndex: 'SelfConsumptionMon',
    width: 200,
}, {
    title: 'Self-Sufficiency Per Month(%)',
    dataIndex: 'SelfSufficiencyMon',
    width: 200,
}, {
    title: 'Self-Consumption Per Year(%)',
    dataIndex: 'SelfConsumptionYear',
    width: 200,
}, {
    title: 'Self-Sufficiency Per Year(%)',
    dataIndex: 'SelfSufficiencyYear',
    width: 200,
}, {
    title: 'Self-Consumption Total(%)',
    dataIndex: 'SelfConsumptionTotal',
    width: 200,
}, {
    title: 'Self-Sufficiency Total(%)',
    dataIndex: 'SelfSufficiencyTotal',
    width: 200,
}, {
    title: 'DRM Status',
    dataIndex: 'DRMStatus',
    width: 160,
}, {
    title: 'PDC(W)',
    dataIndex: 'PDC',
    width: 160,
    render: (v) => {
        v = v*0.1
        return isNaN(v) ? "" : v.toFixed(1)
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'PPeak(W)',
    dataIndex: 'PPeak',
    width: 160,
    render: (v) => {
        v = v*0.1
        return isNaN(v) ? "" : v.toFixed(1)
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'EDay(kWh)',
    dataIndex: 'EDay',
    width: 160,
    render: (v) => {
        return v
    }
}, {
    title: 'EMon(kWh)',
    dataIndex: 'EMon',
    width: 160,
    render: (v) => {
        return v
    }
}, {
    title: 'EYear(kWh)',
    dataIndex: 'EYear',
    width: 160,
    render: (v) => {
        return v
    }
}, {
    title: 'ETotal(kWh)',
    dataIndex: 'ETotal',
    width: 160,
    render: (v) => {
        return v
    }
}, {
    title: 'PDCToLoad(W)',
    dataIndex: 'PDCToLoad',
    width: 160,
    render: (v) => {
        v = v*0.1
        return isNaN(v) ? "" : v.toFixed(1)
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'EDayToLoad(kWh)',
    dataIndex: 'EDayToLoad',
    width: 160,
    render: (v) => {
        return v
    }
}, {
    title: 'EMonToLoad(kWh)',
    dataIndex: 'EMonToLoad',
    width: 160,
    render: (v) => {
        return v
    }
}, {
    title: 'EYearToLoad(kWh)',
    dataIndex: 'EYearToLoad',
    width: 160,
    render: (v) => {
        return v
    }
}, {
    title: 'ETotalToLoad(kWh)',
    dataIndex: 'ETotalToLoad',
    width: 160,
    render: (v) => {
        return v
    }
}, {
    title: 'VMPPT1(V)',
    dataIndex: 'VMPPT1',
    width: 160,
    render: (v) => {
        v = v*0.1
        return isNaN(v) ? "" : v.toFixed(1)
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'IMPPT1(A)',
    dataIndex: 'IMPPT1',
    width: 160,
    render: (v) => {
        v = v*0.01
        return isNaN(v) ? "" : v.toFixed(2)
    },
    transform: {
        multiplicative_inverse: 100
    }
}, {
    title: 'VMPPT2(V)',
    dataIndex: 'VMPPT2',
    width: 160,
    render: (v) => {
        v = v*0.1
        return isNaN(v) ? "" : v.toFixed(1)
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'IMPPT2(A)',
    dataIndex: 'IMPPT2',
    width: 160,
    render: (v) => {
        v = v*0.01
        return isNaN(v) ? "" : v.toFixed(2)
    },
    transform: {
        multiplicative_inverse: 100
    }
}, {
    title: 'BatType',
    dataIndex: 'BatType',
    width: 160,
}, {
    title: 'Ah',
    dataIndex: 'Ah',
    width: 160,
}, {
    title: 'BMS Version',
    dataIndex: 'BMSVersion',
    width: 160,
}, {
    title: 'BMS tatus',
    dataIndex: 'BMSStatus',
    width: 160,
}, {
    title: 'VBat(V)',
    dataIndex: 'VBat',
    width: 160,
    render: (v) => {
        v = v*0.1
        return isNaN(v) ? "" : v.toFixed(1)
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'IBat(A)',
    dataIndex: 'IBat',
    width: 160,
    render: (v) => {
        v = v*0.01
        return isNaN(v) ? "" : v.toFixed(2)
    },
    transform: {
        multiplicative_inverse: 100
    }
}, {
    title: 'PBat(W)',
    dataIndex: 'PBat',
    width: 160,
    render: (v, r) => {
        v = v*0.1
        return isNaN(v) ? "" : v.toFixed(1)
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'SOC',
    dataIndex: 'SOC',
    width: 160,
    render: (v) => {
        return v
    }
}, {
    title: 'SOH',
    dataIndex: 'SOH',
    width: 160,
    render: (v) => {
        return v
    }
}, {
    title: 'BatTemp(°C)',
    dataIndex: 'BatTemp',
    width: 160,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fff) v = v - 0x10000;
        return v; 
    },
    transform: {
        signed: 0x7ffff,
    }
}, {
    title: 'CyclesTimes',
    dataIndex: 'CyclesTimes',
    width: 160,
}, {
    title: 'BatErrorCode',
    dataIndex: 'BatErrorCode',
    width: 160,
}, {
    title: 'EDayBatChrg(kWh)',
    dataIndex: 'EDayBatChrg',
    width: 160,
    render: (v) => {
        return v
    }
}, {
    title: 'EMonBatChrg(kWh)',
    dataIndex: 'EMonBatChrg',
    width: 160,
    render: (v) => {
        return v
    }
}, {
    title: 'EYearBatChrg(kWh)',
    dataIndex: 'EYearBatChrg',
    width: 160,
    render: (v) => {
        return v
    }
}, {
    title: 'ETotalBatChrg(kWh)',
    dataIndex: 'ETotalBatChrg',
    width: 160,
    render: (v) => {
        return v
    }
}, {
    title: 'EDayBatDischrg(kWh)',
    dataIndex: 'EDayBatDischrg',
    width: 160,
    render: (v) => {
        return v
    }
}, {
    title: 'EMonBatDischrg(kWh)',
    dataIndex: 'EMonBatDischrg',
    width: 160,
    render: (v) => {
        return v
    }
}, {
    title: 'EYearBatDischrg(kWh)',
    dataIndex: 'EYearBatDischrg',
    width: 200,
    render: (v) => {
        return v
    }
}, {
    title: 'ETotalBatDischrg(kWh)',
    dataIndex: 'ETotalBatDischrg',
    width: 200,
    render: (v) => {
        return v
    }
}, {
    title: 'PAC1EPS(W)',
    dataIndex: 'PAC1EPS',
    width: 160,
    render: (v) => {
        v = v*0.1
        return isNaN(v) ? "" : v.toFixed(1)
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'PAC2EPS(W)',
    dataIndex: 'PAC2EPS',
    width: 160,
    render: (v) => {
        v = v*0.1
        return isNaN(v) ? "" : v.toFixed(1)
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'PAC3EPS(W)',
    dataIndex: 'PAC3EPS',
    width: 160,
    render: (v) => {
        v = v*0.1
        return isNaN(v) ? "" : v.toFixed(1)
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'FACEPS(Hz)',
    dataIndex: 'FACEPS',
    width: 160,
    render: (v) => {
        v = v*0.01
        return isNaN(v) ? "" : v.toFixed(2)
    },
    transform: {
        multiplicative_inverse: 100
    }
}, {
    title: 'VAC1EPS(V)',
    dataIndex: 'VAC1EPS',
    width: 160,
    render: (v) => {
        v = v*0.1
        return isNaN(v) ? "" : v.toFixed(1)
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'IAC1EPS(A)',
    dataIndex: 'IAC1EPS',
    width: 160,
    render: (v) => {
        v = v*0.01
        return isNaN(v) ? "" : v.toFixed(2)
    },
    transform: {
        multiplicative_inverse: 100
    }
}, {
    title: 'VAC2EPS(V)',
    dataIndex: 'VAC2EPS',
    width: 160,
    render: (v) => {
        v = v*0.1
        return isNaN(v) ? "" : v.toFixed(1)
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'IAC2EPS(A)',
    dataIndex: 'IAC2EPS',
    width: 160,
    render: (v) => {
        v = v*0.01
        return isNaN(v) ? "" : v.toFixed(2)
    },
    transform: {
        multiplicative_inverse: 100
    }
}, {
    title: 'VAC3EPS(V)',
    dataIndex: 'VAC3EPS',
    width: 160,
    render: (v) => {
        v = v*0.1
        return isNaN(v) ? "" : v.toFixed(1)
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'IAC3EPS(A)',
    dataIndex: 'IAC3EPS',
    width: 160,
    render: (v) => {
        v = v*0.01
        return isNaN(v) ? "" : v.toFixed(2)
    },
    transform: {
        multiplicative_inverse: 100
    }
}, {
    title: 'EDayEPS(kWh)',
    dataIndex: 'EDayEPS',
    width: 160,
    render: (v) => {
        return v
    }
}, {
    title: 'EMonEPS(kWh)',
    dataIndex: 'EMonEPS',
    width: 160,
    render: (v) => {
        return v
    }
}, {
    title: 'EYearEPS(kWh)',
    dataIndex: 'EYearEPS',
    width: 160,
    render: (v) => {
        return v
    }
}, {
    title: 'ETotalEPS(kWh)',
    dataIndex: 'ETotalEPS',
    width: 160,
    render: (v) => {
        return v
    }
},
{
    title: 'PAC1GEN(W)',
    dataIndex: 'PAC1GEN',   
    width: 160,
    render: (v) => {
        v = v*0.1
        return isNaN(v) ? "" : v.toFixed(1)
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'PAC2GEN(W)',
    dataIndex: 'PAC2GEN',
    width: 160,
    render: (v) => {
        v = v*0.1
        return isNaN(v) ? "" : v.toFixed(1)
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'PAC3GEN(W)',
    dataIndex: 'PAC3GEN',
    width: 160,
    render: (v) => {
        v = v*0.1
        return isNaN(v) ? "" : v.toFixed(1)
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'FACGEN(Hz)',
    dataIndex: 'FACGEN',
    width: 160,
    render: (v) => {
        v = v*0.01
        return isNaN(v) ? "" : v.toFixed(2)
    },
    transform: {
        multiplicative_inverse: 100
    }
}, {
    title: 'VAC1GEN(V)',
    dataIndex: 'VAC1GEN',
    width: 160,
    render: (v) => {
        v = v*0.1
        return isNaN(v) ? "" : v.toFixed(1)
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'IAC1GEN(A)',
    dataIndex: 'IAC1GEN',
    width: 160,
    render: (v) => {
        v = v*0.01
        return isNaN(v) ? "" : v.toFixed(2)
    },
    transform: {
        multiplicative_inverse: 100
    }
}, {
    title: 'VAC2GEN(V)',
    dataIndex: 'VAC2GEN',
    width: 160,
    render: (v) => {
        v = v*0.1
        return isNaN(v) ? "" : v.toFixed(1)
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'IAC2GEN(A)',
    dataIndex: 'IAC2GEN',
    width: 160,
    render: (v) => {
        v = v*0.01
        return isNaN(v) ? "" : v.toFixed(2)
    },
    transform: {
        multiplicative_inverse: 100
    }
}, {
    title: 'VAC3GEN(V)',
    dataIndex: 'VAC3GEN',
    width: 160,
    render: (v) => {
        v = v*0.1
        return isNaN(v) ? "" : v.toFixed(1)
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'IAC3GEN(A)',
    dataIndex: 'IAC3GEN',
    width: 160,
    render: (v) => {
        v = v*0.01
        return isNaN(v) ? "" : v.toFixed(2)
    },
    transform: {
        multiplicative_inverse: 100
    }
}, {
    title: 'EDayGEN(kWh)',
    dataIndex: 'EDayGEN',
    width: 160,
    render: (v) => {
        return v
    }
}, {
    title: 'EMonGEN(kWh)',
    dataIndex: 'EMonGEN',
    width: 160,
    render: (v) => {
        return v
    }
}, {
    title: 'EYearGEN(kWh)',
    dataIndex: 'EYearGEN',
    width: 160,
    render: (v) => {
        return v
    }
}, {
    title: 'ETotaGEN(kWh)',
    dataIndex: 'ETotaGEN',
    width: 160,
    render: (v) => {
        return v
    }
},
{
    title: 'PAC1LOAD(W)',
    dataIndex: 'PAC1LOAD',
    width: 160,
    render: (v) => {
        v = v*0.1
        return isNaN(v) ? "" : v.toFixed(1)
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'PAC2LOAD(W)',
    dataIndex: 'PAC2LOAD',
    width: 160,
    render: (v) => {
        v = v*0.1
        return isNaN(v) ? "" : v.toFixed(1)
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'PAC3LOAD(W)',
    dataIndex: 'PAC3LOAD',
    width: 160,
    render: (v) => {
        v = v*0.1
        return isNaN(v) ? "" : v.toFixed(1)
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'FACLOAD(Hz)',
    dataIndex: 'FACLOAD',
    width: 160,
    render: (v) => {
        v = v*0.01
        return isNaN(v) ? "" : v.toFixed(2)
    },
    transform: {
        multiplicative_inverse: 100
    }
}, {
    title: 'VAC1LOAD(V)',
    dataIndex: 'VAC1LOAD',
    width: 160,
    render: (v) => {
        v = v*0.1
        return isNaN(v) ? "" : v.toFixed(1)
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'IAC1LOAD(A)',
    dataIndex: 'IAC1LOAD',
    width: 160,
    render: (v) => {
        v = v*0.01
        return isNaN(v) ? "" : v.toFixed(2)
    },
    transform: {
        multiplicative_inverse: 100
    }
}, {
    title: 'VAC2LOAD(V)',
    dataIndex: 'VAC2LOAD',
    width: 160,
    render: (v) => {
        v = v*0.1
        return isNaN(v) ? "" : v.toFixed(1)
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'IAC2LOAD(A)',
    dataIndex: 'IAC2LOAD',
    width: 160,
    render: (v) => {
        v = v*0.01
        return isNaN(v) ? "" : v.toFixed(2)
    },
    transform: {
        multiplicative_inverse: 100
    }
}, {
    title: 'VAC3LOAD(V)',
    dataIndex: 'VAC3LOAD',
    width: 160,
    render: (v) => {
        v = v*0.1
        return isNaN(v) ? "" : v.toFixed(1)
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'IAC3LOAD(A)',
    dataIndex: 'IAC3LOAD',
    width: 160,
    render: (v) => {
        v = v*0.01
        return isNaN(v) ? "" : v.toFixed(2)
    },
    transform: {
        multiplicative_inverse: 100
    }
}, {
    title: 'EDayLOAD(kWh)',
    dataIndex: 'EDayLOAD',
    width: 160,
    render: (v) => {
        return v
    }
}, {
    title: 'EMonLOAD(kWh)',
    dataIndex: 'EMonLOAD',
    width: 160,
    render: (v) => {
        return v
    }
}, {
    title: 'EYearLOAD(kWh)',
    dataIndex: 'EYearLOAD',
    width: 160,
    render: (v) => {
        return v
    }
}, {
    title: 'ETotalLOAD(kWh)',
    dataIndex: 'ETotalLOAD',
    width: 160,
    render: (v) => {
        return v
    }
},
{
    title: 'PAC1GRID(W)',
    dataIndex: 'PAC1GRID',
    width: 160,
    render: (v) => {
        v = v*0.1
        return isNaN(v) ? "" : v.toFixed(1)
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'PAC2GRID(W)',
    dataIndex: 'PAC2GRID',
    width: 160,
    render: (v) => {
        v = v*0.1
        return isNaN(v) ? "" : v.toFixed(1)
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'PAC3GRID(W)',
    dataIndex: 'PAC3GRID',
    width: 160,
    render: (v) => {
        v = v*0.1
        return isNaN(v) ? "" : v.toFixed(1)
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'FACGRID(Hz)',
    dataIndex: 'FACGRID',
    width: 160,
    render: (v) => {
        v = v*0.01
        return isNaN(v) ? "" : v.toFixed(2)
    },
    transform: {
        multiplicative_inverse: 100
    }
}, {
    title: 'VAC1GRID(V)',
    dataIndex: 'VAC1GRID',
    width: 160,
    render: (v) => {
        v = v*0.1
        return isNaN(v) ? "" : v.toFixed(1)
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'IAC1GRID(A)',
    dataIndex: 'IAC1GRID',
    width: 160,
    render: (v) => {
        v = v*0.01
        return isNaN(v) ? "" : v.toFixed(2)
    },
    transform: {
        multiplicative_inverse: 100
    }
}, {
    title: 'VAC2GRID(V)',
    dataIndex: 'VAC2GRID',
    width: 160,
    render: (v) => {
        v = v*0.1
        return isNaN(v) ? "" : v.toFixed(1)
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'IAC2GRID(A)',
    dataIndex: 'IAC2GRID',
    width: 160,
    render: (v) => {
        v = v*0.01
        return isNaN(v) ? "" : v.toFixed(2)
    },
    transform: {
        multiplicative_inverse: 100
    }
}, {
    title: 'VAC3GRID(V)',
    dataIndex: 'VAC3GRID',
    width: 160,
    render: (v) => {
        v = v*0.1
        return isNaN(v) ? "" : v.toFixed(1)
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'IAC3GRID(A)',
    dataIndex: 'IAC3GRID',
    width: 160,
    render: (v) => {
        v = v*0.01
        return isNaN(v) ? "" : v.toFixed(2)
    },
    transform: {
        multiplicative_inverse: 100
    }
}, {
    title: 'EDayToGrid(kWh)',
    dataIndex: 'EDayToGrid',
    width: 160,
    render: (v) => {
        return v
    }
}, {
    title: 'EMonToGrid(kWh)',
    dataIndex: 'EMonToGrid',
    width: 160,
    render: (v) => {
        return v
    }
}, {
    title: 'EYearToGrid(kWh)',
    dataIndex: 'EYearToGrid',
    width: 160,
    render: (v) => {
        return v
    }
}, {
    title: 'ETotalToGrid(kWh)',
    dataIndex: 'ETotalToGrid',
    width: 160,
    render: (v) => {
        return v
    }
}, {
    title: 'EDayFromGrid(kWh)',
    dataIndex: 'EDayFromGrid',
    width: 160,
    render: (v) => {
        return v
    }
}, {
    title: 'EMonFromGrid(kWh)',
    dataIndex: 'EMonFromGrid',
    width: 160,
    render: (v) => {
        return v
    }
}, {
    title: 'EYearFromGrid(kWh)',
    dataIndex: 'EYearFromGrid',
    width: 160,
    render: (v) => {
        return v
    }
}, {
    title: 'ETotalFromGrid(kWh)',
    dataIndex: 'ETotalFromGrid',
    width: 160,
    render: (v) => {
        return v
    }
}, {
    title: 'ErrorCode1',
    dataIndex: 'ErrorCode1',
    width: 160,
}, {
    title: 'ErrorCode2',
    dataIndex: 'ErrorCode2',
    width: 160,
}];